import { render } from "./StockPhotos.vue?vue&type=template&id=46fbffd8&scoped=true"
import script from "./StockPhotos.vue?vue&type=script&lang=js"
export * from "./StockPhotos.vue?vue&type=script&lang=js"

import "./StockPhotos.vue?vue&type=style&index=0&id=46fbffd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46fbffd8"]])

export default __exports__